import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Contact API
export const submitContactForm = async (contactData) => {
  try {
    const response = await axios.post(`${API}/contact`, contactData);
    return response.data;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
};

// Testimonials API
export const getTestimonials = async (featured = null) => {
  try {
    const params = featured !== null ? { featured } : {};
    const response = await axios.get(`${API}/testimonials`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching testimonials:', error);
    throw error;
  }
};

// Company Info API
export const getCompanyInfo = async () => {
  try {
    const response = await axios.get(`${API}/company-info`);
    return response.data;
  } catch (error) {
    console.error('Error fetching company info:', error);
    throw error;
  }
};

// Services API
export const getServices = async () => {
  try {
    const response = await axios.get(`${API}/services`);
    return response.data;
  } catch (error) {
    console.error('Error fetching services:', error);
    throw error;
  }
};

// Impact Stories API
export const getImpactStories = async () => {
  try {
    const response = await axios.get(`${API}/impact-stories`);
    return response.data;
  } catch (error) {
    console.error('Error fetching impact stories:', error);
    throw error;
  }
};

// Payment Options API
export const getPaymentOptions = async () => {
  try {
    const response = await axios.get(`${API}/payment-options`);
    return response.data;
  } catch (error) {
    console.error('Error fetching payment options:', error);
    throw error;
  }
};